import { render, staticRenderFns } from "./text-numeric-submitted-preview.vue?vue&type=template&id=7ff99570&scoped=true&"
import script from "./text-numeric-submitted-preview.vue?vue&type=script&lang=js&"
export * from "./text-numeric-submitted-preview.vue?vue&type=script&lang=js&"
import style0 from "./text-numeric-submitted-preview.vue?vue&type=style&index=0&id=7ff99570&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff99570",
  null
  
)

component.options.__file = "text-numeric-submitted-preview.vue"
export default component.exports